const HOUR_MS = 60 * 60 * 1000;
const CELL_COUNT = 24;
/**
 * Project a merged schedule onto a fixed 24-hour forward window and identify
 * the next on-shift hour beyond `now`. UTC throughout — the UI converts to
 * the viewer's local time for display.
 */
export function computeScheduleWindow(merged, now) {
    const kindByHour = collectKindByHour(merged);
    const startMs = startOfUtcHour(now).getTime();
    const cells = [];
    for (let i = 0; i < CELL_COUNT; i++) {
        const startUtc = new Date(startMs + i * HOUR_MS);
        const kind = kindByHour.get(startUtc.getTime()) ?? 'off';
        cells.push({ startUtc, kind });
    }
    const nextScheduledAt = findNextOnShiftAfter(kindByHour, now);
    return { cells, nextScheduledAt };
}
/**
 * Walk the merged segments twice so `step-away` always wins over shift sources
 * at the same hour, regardless of segment order in the input. A single pass
 * that trusted input ordering would be fragile against backend changes — the
 * merged schedule contract doesn't promise a particular ordering.
 */
function collectKindByHour(merged) {
    const map = new Map();
    for (const day of merged.days) {
        for (const segment of day.segments) {
            if (segment.source === 'override-remove')
                continue;
            if (segment.source === 'step-away')
                continue;
            forEachHour(segment.startsAt, segment.endsAt, (ms) => map.set(ms, 'on-shift'));
        }
    }
    for (const day of merged.days) {
        for (const segment of day.segments) {
            if (segment.source !== 'step-away')
                continue;
            forEachHour(segment.startsAt, segment.endsAt, (ms) => map.set(ms, 'on-break'));
        }
    }
    return map;
}
function forEachHour(startsAt, endsAt, visit) {
    const startMs = Date.parse(startsAt);
    const endMs = Date.parse(endsAt);
    const firstHourMs = Math.floor(startMs / HOUR_MS) * HOUR_MS;
    for (let ms = firstHourMs; ms < endMs; ms += HOUR_MS) {
        visit(ms);
    }
}
function findNextOnShiftAfter(kindByHour, now) {
    const cutoff = startOfUtcHour(now).getTime() + HOUR_MS;
    let soonest = null;
    for (const [t, kind] of kindByHour) {
        if (kind !== 'on-shift')
            continue;
        if (t >= cutoff && (soonest === null || t < soonest)) {
            soonest = t;
        }
    }
    return soonest === null ? null : new Date(soonest);
}
function startOfUtcHour(d) {
    const out = new Date(d);
    out.setUTCMinutes(0, 0, 0);
    return out;
}
//# sourceMappingURL=schedule-window.js.map